import { type PaginatedList } from "@mylaunch/components/ui"
import { type Post } from "@apps/gwservice/types"
import { useQueryClient } from "@tanstack/react-query"
import { useRef } from "react"
import { Result } from "@praha/byethrow"
import { InfinitePostList } from "~/components/infinite-post-list"
import { MessageInput } from "~/features/messages/components/message-input"
import { topicContentQueryKeys } from "../query-keys"
import { addPost, addPostCodec } from "../server/topic.functions"

interface Props {
  topicId: number
  initialItems: Post[]
  initialNextPage?: number
  loadMore: (page: number) => Result.ResultAsync<PaginatedList<Post>, string>
}

export function AddablePostList({ topicId, initialItems, initialNextPage, loadMore }: Props) {
  const queryClient = useQueryClient()
  const topAnchorRef = useRef<HTMLDivElement>(null)

  return (
    <>
      <div ref={topAnchorRef} />
      <InfinitePostList
        initialItems={initialItems}
        initialNextPage={initialNextPage}
        loadMore={loadMore}
      />
      <MessageInput
        onSubmit={async (text, file) => {
          const result = await addPost(addPostCodec.toFormData({ topicId, text, file }))
          if (Result.isFailure(result) || !Result.unwrap(result)) return false
          await queryClient.invalidateQueries({ queryKey: topicContentQueryKeys(topicId) })
          return true
        }}
        onSubmitted={() => {
          requestAnimationFrame(() => {
            topAnchorRef.current?.scrollIntoView({
              behavior: "smooth",
              block: "start",
            })
          })
        }}
        placeholder="Написать пост..."
      />
    </>
  )
}
